







































































































































































































































































































































































































































































































































































































































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'products',
      'ingredients', 'prescript', 'prescript_meta'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      name: { required },
      product_type_id: { required },
      done_delay: { },
      ferment_delay: { },
      upper_ok: { },
      upper_middle: { },
      upper_warn: { },
      lower_ok: { },
      lower_middle: { },
      lower_warn: { },
      water_border_ok: { },
      water_border_ko: { },
      lossless_loading: { },
      lossy_loading: { },
      loss_rate: { },
      temp_low_border_ok: {},
      temp_border_ok: {},
      temp_high_border_ok: {},
    }

    return {
      form: rules,
      prescript: {
        total_weight: {required},
        datetime: {required},
        close_date: {},
        type: {},
      }
    }
  }
})
export default class BasesManagerForm extends Vue {
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any
  @Prop() params!: any

  numbers: any = 0

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  get config() {
    return this.params || this.$route.params || {}
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }


  draggingRow: any = null
  draggingRowIndex: any = null

  dragstart(payload: any) {
    this.draggingRow = payload.row
    this.draggingRowIndex = payload.index
    payload.event.dataTransfer.effectAllowed = 'copy'
  }
  dragover(payload: any) {
    payload.event.dataTransfer.dropEffect = 'copy'
    payload.event.target.closest('tr').classList.add('is-selected')
    payload.event.preventDefault()

  }
  dragleave(payload: any) {
    payload.event.target.closest('tr').classList.remove('is-selected')
    payload.event.preventDefault()
  }
  drop(payload: any) {
    payload.event.target.closest('tr').classList.remove('is-selected')
    const droppedOnRowIndex = payload.index
    this.$store.dispatch(`${STORE_KEY}/setPositionIngredient`, {
      oldIndex: this.draggingRowIndex, newIndex: payload.index
    })
  }

  get isNew() {
    return this.config.id == 'new'
  }

  get toolTip_41() {
    return this.form.tooltip_41 ? this.form.tooltip_41.data : [5, 6.5]
  }

  get toolTip_42() {
    return this.form.tooltip_42 ? this.form.tooltip_42.data : [5, 6.5]
  }

  get toolTip_43() {
    return this.form.tooltip_43 ? this.form.tooltip_43.data : [5, 6.5]
  }

  get toolTip_44() {
    return this.form.tooltip_44 ? this.form.tooltip_44.data : [5, 6.5]
  }

  get toolTip_71() {
    return this.form.tooltip_71 ? this.form.tooltip_71.data : [5, 6.5]
  }

  get toolTip_72() {
    return this.form.tooltip_72 ? this.form.tooltip_72.data : [5, 6.5]
  }

  get toolTip_73() {
    return this.form.tooltip_73 ? this.form.tooltip_73.data : [5, 6.5]
  }

  get toolTip_74() {
    return this.form.tooltip_74 ? this.form.tooltip_74.data : [5, 6.5]
  }
  get temp_border_ok() {
    return this.form.temp_border_ok ? this.form.temp_border_ok.data : [34, 38]
  }
  get temp_low_border_ok() {
    return this.form.temp_low_border_ok ? this.form.temp_low_border_ok.data : [33, 34]
  }
  get temp_high_border_ok() {
    return this.form.temp_high_border_ok ? this.form.temp_high_border_ok.data : [38, 40]
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.config.id
      });
    }
  }
  public goBack() {
    if (!this.params) {
      this.$router.push({ name: 'bases-list' });
    } else {
      this.$router.back();
      this.$emit('close');
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  addPrescriptWaterBorder() {
    this.$store.dispatch(`${STORE_KEY}/addPrescriptWaterBorder`);
  }

  removePrescriptWaterBorder(index: any) {
    this.$store.dispatch(`${STORE_KEY}/removePrescriptWaterBorder`, index);
  }


  addItem(base_id: any) {
    this.$store.dispatch(`${STORE_KEY}/addItem`, {base_id});
  }

  removeItem(index: any) {
    this.$store.dispatch(`${STORE_KEY}/removeItem`, index);
  }

  addIngredient() {
    this.$store.dispatch(`${STORE_KEY}/addIngredient`);
  }

  copyIngredient(idx: number) {
    this.$store.dispatch(`${STORE_KEY}/copyIngredient`, {idx});
  }

  delIngredient(idx: number) {
    this.$store.dispatch(`${STORE_KEY}/delIngredient`, {idx});
  }

  changeIngredientValue(idx: number, field: any, $event: any) {
    this.$store.dispatch(`${STORE_KEY}/changeIngredientValue`, {
      idx, field, newValue: $event
    });
  }

  changePrescriptValue(field: any, $event: any) {
    this.$store.dispatch(`${STORE_KEY}/changePrescriptValue`, {
      field, newValue: $event
    });
  }

  changePrescriptWaterBorderValue(idx: number, field: any, $event: any) {
    this.$store.dispatch(`${STORE_KEY}/changePrescriptWaterBorderValue`, {
      idx, field, newValue: $event
    });
  }

  changeIngredientObject(index: number, ingredient: any) {
    this.changeIngredientValue(index, 'protein_percent', ingredient.protein)
    this.changeIngredientValue(index, 'fats_percent', ingredient.fats)
    this.changeIngredientValue(index, 'carbohydrate_percent', ingredient.carbohydrate)
  }

  changeProductValue(index: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeProductValue`, {
      index, field, newValue: value
    });
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
      })
      .catch((e) => {
        console.log('error => ', e);

        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

